import React, { useContext, useEffect } from 'react';
import CollapsibleArea, {
    CollapsibleAreaContext,
} from '../../../components/CollapsibleArea';
import Switch from '../../../components/Switch';
import OrderExpiryDropdown from '../../../components/OrderExpiryDropdown';
import clsx from 'clsx';
import LimitPriceInput from '../../../components/LimitPriceInput';
import { TradePair } from '../../../context/chart/chartTypes';

type LimitPriceDropdownProps = {
    selectedTradePair: TradePair | undefined;
    amount: string;
    date: Date | undefined;
    limitPriceChecked: boolean;
    orderExpiryChecked: boolean;
    disabled?: boolean;
    onChange: (amount: string) => void;
    handleDateChange: React.Dispatch<React.SetStateAction<Date | undefined>>;
    toggleLimitPrice: () => void;
    toggleOrderExpiry: () => void;
};

type OrderExpiryDropdownProps = {
    date: Date | undefined;
    orderExpiryChecked: boolean;
    disabled?: boolean;
    handleDateChange: React.Dispatch<React.SetStateAction<Date | undefined>>;
    toggleOrderExpiry: () => void;
};

const LimitPriceDropdown: React.FC<LimitPriceDropdownProps> = ({
    selectedTradePair,
    amount,
    date,
    limitPriceChecked,
    orderExpiryChecked,
    disabled,
    onChange,
    handleDateChange,
    toggleLimitPrice,
    toggleOrderExpiry,
}) => {
    return (
        <div className='limit-price-dropdown'>
            <div className={clsx('collapsible-area-trigger-container', { disabled })}>
                <span>Limit Order</span>
                <Switch disabled={disabled} onToggle={toggleLimitPrice} />
            </div>
            <CollapsibleArea collapsed={limitPriceChecked}>
                <LimitPriceInput
                    selectedTradePair={selectedTradePair}
                    onChange={onChange}
                    value={amount}
                    disabled={disabled}
                    variant='secondary'
                />
                <OrderExpiry
                    orderExpiryChecked={orderExpiryChecked}
                    toggleOrderExpiry={disabled ? () => {} : toggleOrderExpiry}
                    date={date}
                    handleDateChange={handleDateChange}
                    disabled={disabled}
                />
            </CollapsibleArea>
        </div>
    );
};

export default LimitPriceDropdown;

const OrderExpiry: React.FC<OrderExpiryDropdownProps> = ({
    date,
    orderExpiryChecked,
    disabled,
    handleDateChange,
    toggleOrderExpiry,
}) => {
    const { updateCollapsedHeight } = useContext(CollapsibleAreaContext);

    const onDateChange = (value?: any) => {
        handleDateChange(value);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            updateCollapsedHeight();
        }, 100);

        setTimeout(() => {
            clearInterval(interval);
        }, 1000);
    }, [orderExpiryChecked, updateCollapsedHeight]);

    return (
        <OrderExpiryDropdown
            value={date}
            orderExpiryChecked={orderExpiryChecked}
            onChange={onDateChange}
            toggleOrderExpiry={toggleOrderExpiry}
            disabled={disabled}
        />
    );
};
